import type { HexColor } from "./hex-color/hex-color";
import type { HSL } from "./hsla-color/hsl-color";
import type { HSLA } from "./hsla-color/hsla-color";
import { isLightOrDarkColor } from "./is-light-or-dark-color";
import type { RGB } from "./rgba-color/rgb-color";
import type { RGBA } from "./rgba-color/rgba-color";

const isDarkColor = (color: RGB | RGBA | HSL | HSLA | HexColor): boolean => {
    return isLightOrDarkColor(color) === "dark";
};
export { isDarkColor };
